import React from 'react'

import $ from 'jquery';
import Pagination from "react-js-pagination";
import { Helmet } from "react-helmet";

import {RotatingLines} from "react-loader-spinner";

import LazyLoadingList from '../components/common/LazyLoadingList'

import Product from '../components/Product'

import General from '../utils/General'
import Backend from '../utils/Backend'
import ScriptCache from '../utils/ScriptCache'
import ProductSettingsModal from "../components/modal/ProductSettingsModal";
import Website from "../utils/Website";
import Event from "../utils/Event";
import { BreadcrumbNavigation, handleBreadcrumbClick, generateBreadCrumbsStyles } from './Product';

import { StorefrontPopupWrapper } from '../components/modal/PopupManagerModal';
import PopupManagerModal from '../components/modal/PopupManagerModal';
import AuthManager from '../utils/AuthManager';
import ActionToolbar from '../components/ActionToolbar';
import SEOTag from "../components/SEOTag";

const SORT_OPTIONS = [
  { label: "Price: High to Low", value: "price_desc" },
  { label: "Price: Low to High", value: "price_asc" },
  { label: "Name: A to Z", value: "name_asc" },
  { label: "Name: Z to A", value: "name_desc" },
];

export default class Shop extends React.Component {
  constructor(props) {
    super(props)

    let categoryIndex = 4
    if(!Website.hasFunnelReference()){
      categoryIndex = 3
    }

    this.state = {
      category: window.location.pathname.split("/")[categoryIndex],
      categories: [],
      allProducts: [],
      products: [],
      productIds: [],
      loading: true,
      loadingShop: true,
      initialProductsLoading: true,
      shop: props.shop,
      collectionMode: props.collectionMode,
      pageSize: props.website.extra?.product_page_settings?.product_page_count || 18,
      show_pagination: props.website.extra?.product_page_settings?.show_pagination,
      loadedPages: 1,
      displayedProduts: [],
      pageNo: General.getUrlParameter("page") || 1,
      count: 1,
      website: window.CURRENT_WEBSITE,
      editable: props.editable,
      page: props.page,
      endpoint: `${window.Api.Base}/products?shop_id=${props.website.id}&active=true&search_term=`,
      data: {
        campaignId: window.CURRENT_WEBSITE.campaign_id,
        filter1_column: "productName",
        filter1_condition: "contains",
        filter1_value: ""
      },
      collectionName: "",
      showPopupManagerModal: false
    }

    this.lazyLoadingList = React.createRef()

    this._updateWebsite = General.debounce(
      () => {
        Backend.updateWebsite({
          slug: this.state.website.slug,
          extra: this.state.website.extra,
          checkout_type: this.state.website.checkout_type,
        });
      },
      1000,
      false
    );
  }

  componentDidMount() {
    this._setup()
    window.addEventListener('scroll', this._handleScroll);
    if (this.state.editable) {
      Backend.getPages(window.CURRENT_WEBSITE_ID);
      Backend.getCCPages();
    }
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this._handleScroll);
    Event.off('WEBSITE_UPDATED');
  }

  _setup(){
    this._loadProducts()
    this._loadJs()
  }

  async _onDashboardClicked() {
    this.setState({savingPage: true})
    Backend.generateThumbnail();
    await Backend.savePage();
    General.openEditFunnel();
  }

  _loadJs(){
    ScriptCache.loadDefaults()
    setTimeout(() => {
      General.updateAll()
    }, 300)
  }

  _loadProducts() {
    let {
      pageNo,
      pageSize,
      website,
      category,
      productIds,
      loadedPages,
      show_pagination
    } = this.state

    this.setState({loading: true})

    if(this.state.collectionMode){
      Backend.getCollectionProducts(category)
      .then(response => {
        const allProducts = General.clone(response.products)
        console.log("^^^^^", response)
        if (!show_pagination) {
          const displayedProducts = allProducts.slice(0, loadedPages * pageSize);
          this.setState({
            allProducts,
            displayedProducts,
            filteredProducts: allProducts,
            count: response.count,
            loading: false,
            collectionName: response.collectionName
          });
        } else {
          this.setState({
            allProducts,
            filteredProducts: allProducts,
            products: this._paginateProducts(allProducts, pageNo),
            count: response.count,
            loading: false,
            collectionName: response.collectionName
          });
        }
      }).catch(() => this.setState({loading: false, products: []}))
    }else{
      Backend.getProducts(productIds.join(",")).then(products => {
        if(!show_pagination){
          const displayedProducts = products.slice(0, loadedPages * pageSize);
          this.setState({products, displayedProducts, loading: false});
        } else {
          this.setState({products, loading: false});
        }
      }).catch(() => this.setState({loading: false, products: []}))
    }
  }

  _handleScroll = () => {
    if(this.state.show_pagination) return;
  
    const scrollable = document.documentElement;
    const scrollTop = scrollable.scrollTop;
    const scrollHeight = scrollable.scrollHeight;
    const clientHeight = scrollable.clientHeight;
  
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      const { loadedPages, allProducts, pageSize, displayedProducts } = this.state;
  
      const nextLoadedPages = loadedPages + 1;
      const newProducts = allProducts.slice(0, nextLoadedPages * pageSize);
  
      if(newProducts.length > displayedProducts.length){
        this.setState({
          loadedPages: nextLoadedPages,
          displayedProducts: newProducts
        });
      }
    }
  }

  refresh() {
    let {
      data,
      searchTerm
    } = this.state

    this.setState({loading: true})
    Backend.useProductQuery(searchTerm).then(productIds => {
      if(productIds.length > 0){
        this.setState({productIds}, () => this._loadProducts())
      }else{
        this.setState({products: [], loading: false})
      }
    })
  }

  _paginateProducts(products, pageNo){
    let {
      pageSize,
    } = this.state

    return products.slice((pageNo - 1) * pageSize, pageNo * pageSize);
  }

  _getFilteredAndPaginatedData(allProduct, searchTerm, pageSize, page=1) {
    let filteredData = allProduct;

    if(searchTerm) {
      filteredData = filteredData.filter(item => item.productName?.toLowerCase().includes(searchTerm.toLowerCase()) || item.productDescription?.toLowerCase().includes(searchTerm.toLowerCase()))
    }

    let paginatedData = this._paginateProducts(filteredData, page);

    return { filteredData, paginatedData }
  }

  _getPrice(product) {
    let price = product.cycle1_price

    if(product.variants.length > 0){
      if(product.variants[0].price){
        price = product.variants[0].price
      }
    }

    return price
  }

  _handleSort(option) {
    let {
      filteredProducts
    } = this.state

    if(!filteredProducts){
      return
    }

    let sorted = [...filteredProducts]

    switch (option) {
      case "price_desc":
        sorted.sort((a, b) => this._getPrice(b) - this._getPrice(a));
        break;
      case "price_asc":
        sorted.sort((a, b) => this._getPrice(a) - this._getPrice(b));
        break;
      case "name_asc":
        sorted.sort((a, b) => a.productName.localeCompare(b.productName));
        break;
      case "name_desc":
        sorted.sort((a, b) => b.productName.localeCompare(a.productName));
        break;
      default:
        break;
    }

    this.setState({
      products: sorted,
      filteredProducts: sorted
    })
  }

  _handleSearch = General.debounce(() => {
    let {
      allProducts,
      pageSize,
      searchTerm,
    } = this.state

    if(!allProducts){
      return
    }

    let { filteredData, paginatedData } = this._getFilteredAndPaginatedData(
      allProducts, searchTerm, pageSize
    );

    this.setState({
      filteredProducts: filteredData,
      products: paginatedData
    })

  }, 500)

  _update(website, callback) {
    let pageSize = website.extra?.product_page_settings?.product_page_count || this.state.pageSize;
    const show_pagination = website.extra?.product_page_settings?.show_pagination;
    const displayedProducts = this.state.allProducts.slice(0, pageSize);
    this.setState({ website, pageSize, show_pagination, displayedProducts,  loadedPages: 1 }, () => {
      if (callback) {
        callback();
      }
      this._updateWebsite();
    });
  }

  _renderProducts(){
    let {
      loading,
      endpoint,
      products,
      show_pagination,
      displayedProducts,
      website
    } = this.state

    if(loading){
      return this._renderProductsLoading()
    }
    let productList = show_pagination ? products : displayedProducts;
    if(productList.length < 1){
      return (
        <div className='col'>
          <h3 className="text-center">No products match your search query</h3>
        </div>
      )
    }

    return productList.map(product => {
      return (
        <Product
          key={product.campaignProductId}
          product={product}
          onAddToCartPressed={(product, variant, customMessage, quantity) => this.props.onAddToCartPressed(product, variant, customMessage, quantity)}
          data={{
            extra: {
              display_product_tile_color_swatch: website?.extra?.product_page_settings?.display_collection_product_tile_color_swatch,
              product_tile_color_swatch: website?.extra?.product_page_settings?.collection_product_tile_color_swatch
            },
            block_id: "123"
          }}
        />
      )
    })

  }

  _renderProductsLoading(){
    return (
      <>
        <Product product={null} />
        <Product product={null} />
        <Product product={null} />
      </>
    )
  }

  _renderFilters(){
    let {
      website,
      category,
      categories,
    } = this.state

    return (
      <>
        <div className="row filters align-items-center">

          <div className="col-4">
            <h2 className="m-0" style={{ color: website?.extra?.product_page_settings?.collection_text_color}}>{ website.name }</h2>
          </div>

          <div className="col-5 filter-search">
            <div className="input-search" style={{ "--placeholder-color": website?.extra?.product_page_settings?.collection_text_color }}>
              <input
                type="search" name="search" placeholder="Search..." className="collect-input"
                onChange={e => {
                  this.setState({
                    searchTerm: e.target.value
                  }, () => this._handleSearch())
                }}
              />
              <button>
                <span class="material-icons">search</span>
              </button>
            </div>
          </div>

          <div className="col-3 filter-category" style={{ color: website?.extra?.product_page_settings?.collection_text_color}}>
            <div className="input-select">
              <select
                placeholder={"Sort"}
                style={{ color: website?.extra?.product_page_settings?.collection_text_color}}
                onChange={e => {
                  let value = e.target.value
                  this._handleSort(value)
                }}
              >
                <option value="">Sort by</option>
                {
                  SORT_OPTIONS.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))
                }
              </select>
            </div>
          </div>
        </div>
      </>
    )
  }

  _handleNextPage(page){
    let {
      allProducts
    } = this.state;

    this.setState({
      products: this._paginateProducts(General.clone(allProducts), page),
      pageNo: page,
    }, () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    })
  }

  _renderProductSettingsButton() {
    let {
      editable,
      savingPage,
      page,
      website
    } = this.state;

    if (!editable) {
      return;
    }

    let className = "btn-fixed-left-container ignore-user-set-font";

    return (
      <div className={className}>

        <div className="d-flex">
          <button
            className="btn"
            title="Back to Funnel"
            onClick={() => this._onDashboardClicked()}
          >
            <span className="btn__text">
              {
                savingPage ?
                  <RotatingLines
                    height={24}
                    width={"24"}
                    strokeColor={"#ffffff"}
                  />
                  :
                  <span className="material-icons">exit_to_app</span>
              }
              <span className="slide-text">Back to Funnel</span>
            </span>
          </button>
        </div>

        {/* Starts : Button 01 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Styling"
            onClick={() => this.setState({ showProductSettingsModal: true })}
          >
            <span className="btn__text">
              <span class="material-icons">brush_outline</span>
              <span class="slide-text">Product Settings</span>
            </span>
          </a>
        </div>
        {/* End : Button 01 */}

        {/* Starts : Button 02 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Styling"
            onClick={() => this.setState({showPopupManagerModal: true})}
          >
            <span className="btn__text">
              <span class="material-icons">wysiwyg</span>
              <span class="slide-text">Popup Manager</span>
            </span>
          </a>
          <div className="c-tool-tips six">
            {General.renderTourButtonTitle("right", "Popup Manager")}
          </div>
        </div>
        {/* End : Button 02 */}
        {/* Starts : Button 08 / 09 */}
        { (editable && AuthManager.accessToken) &&
          <>
            <ActionToolbar variant="right-bottom" page={page} website={website}/>
          </>
        }
        {/* End : Button 08 / 09 */}
      </div>
    );
  }

  _renderMeta(){
    let {
      shop,
    } = this.state

    if(shop == null){
       return null
    }
    let website = shop.website

    let name = "Shop | "+website.name
    let favIconUrl = website.favicon ? website.favicon.original : "/favicon.ico"

    return (
      <Helmet>
        <title>{ name }</title>
        <meta name="description" content={ website.descrption } />
        <meta name="keywords" content={ website.keywords } />
        <link rel="icon" href={ favIconUrl }/>
        <meta property="og:title" content={ website.name }/>
        <meta property="og:image" content={ favIconUrl }/>
        <meta property="og:description" content={ website.descrption }/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content={ window.location.href }/>
      </Helmet>
    )
  }

  _renderSEO() {
    let { website } = this.state;
    if(website.seo_tag) {
      return (<SEOTag {...website.seo_tag} />);
    }
    return null;
  }

  _renderPopupManagerModal(){
    let {
      showPopupManagerModal,
      editable,
      website
    } = this.state
    
    return (
      <>
        {showPopupManagerModal && <PopupManagerModal
          show={showPopupManagerModal}
          onHide={() => this.setState({ showPopupManagerModal: false })}
          editable={editable}
          websitePopupCollection={website?.extra?.popup_collection || []}
          website={website}
        />}
      </>
    )
  }
  _getDeviceFromWidth = () => {
    const width = window?.innerWidth || 992;
    if (width > 992) return 'desktop';
    if (width > 768) return 'tabletlarge';
    if (width > 600) return 'tablet';
    if (width > 480) return 'mobilelarge';
    return 'mobile';
  };
  _isComponentVisible (componentKey) {
    const deviceType = typeof window !== 'undefined' ? this._getDeviceFromWidth() : 'desktop';
    const settings = this.state?.website?.extra?.product_page_settings || {};
    const visibility = settings?.visibility?.[componentKey];
    if (!visibility) {
      return true;
    }
    return visibility[deviceType] !== false;
  }
  render() {
    let {
      count,
      pageNo,
      pageSize,
      website,
      editable,
      filteredProducts,
      collectionName,
      show_pagination
    } = this.state
    const breadcrumbs = BreadcrumbNavigation("collection", collectionName, website?.collection_page_slug);
    const breadCrumbsStyles = generateBreadCrumbsStyles(website?.extra?.product_page_settings);
    return (
      <>
      {/* TBD */}
        <div className="main-container page shop">
          { this._renderMeta() }
          {this._renderSEO()}
          <section className="product-blocks" style={{ backgroundColor: website?.extra?.product_page_settings?.collection_body_bg_color}}>
            <div className='container' style={{ position: 'relative' }}>
              { this._isComponentVisible("breadCrumbsOptions") ? <div style={{...breadCrumbsStyles, marginBottom: "20px", marginTop: "20px" }}>
                <nav style={{ display: "flex", gap: "8px"}}>
                  {breadcrumbs.map((crumb, idx) => (
                    <span key={crumb.url} style={{ display: "flex", alignItems: "center" }}>
                      {idx > 0 && <span style={{ margin: "0 6px", color: breadCrumbsStyles.carrotColor}}>{">"}</span>}
                      {idx === breadcrumbs.length - 1 ? (
                        <span style={{color: breadCrumbsStyles.textColor}}>{crumb.label}</span>
                      ) : (
                        <a href={crumb.url} style={{color: breadCrumbsStyles.linkColor}} onClick={() => handleBreadcrumbClick(crumb.url)}>{crumb.label}</a>
                      )}
                    </span>
                  ))}
                </nav>
              </div> : null }
            </div>
            <div className="container">

              { this._renderFilters() }

              <div className="row mt-5">

                { this._renderProducts() }

              </div>

              {
                count > pageSize && show_pagination &&
                <div className="row mt-5">
                  <Pagination
                    activePage={parseInt(pageNo)}
                    itemsCountPerPage={pageSize}
                    totalItemsCount={filteredProducts.length}
                    pageRangeDisplayed={5}
                    hideFirstLastPages={true}
                    hideDisabled={true}
                    innerClass={"pagination react-js-pagination"}
                    itemClass={"page-item"}
                    linkClass={"page-link"}
                    activeClass={"active"}
                    onChange={(page) => {
                      this._handleNextPage(page)
                    }}
                  />
                </div>
              }

            </div>
          </section>
        </div>
        {this._renderProductSettingsButton()}
        <ProductSettingsModal
          show={this.state.showProductSettingsModal}
          website={website}
          onCheckoutTypeUpdated={(checkoutType) => {
            website.checkout_type = checkoutType
            this._update(website)
          }}
          onUpdated={(data) => {
            if(!website.extra){
              website.extra = {product_page_settings: null}
            }
            website.extra.product_page_settings = data
            this._update(website, this._handleSearch())
          }}
          onHide={() => this.setState({showProductSettingsModal: false})}
        />
        <div id="notification-container" class="text-center">
          <div id="notification-content"></div>
        </div>
        {this._renderPopupManagerModal()}
        {!this.state.showPopupManagerModal && <StorefrontPopupWrapper
            updateCart={(cart) => {
              this.props.onUpdatedCart(cart);
            }}
            editableProp={editable}
            website={website}
          />
        }
      </>
    )
  }
}
